import { KineticMarkerData } from '@kinetic-ui/shared';

export enum WeatherLayerState {
  WEATHER_STATIONS = 'WEATHER_STATIONS',
}

export type WeatherMarkerProps = KineticMarkerData;
